import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { StatusBadge } from "../dashboard/DashboardUI";
import { DocumentList } from "./RequestDetailModal";
import { getTicketDocuments } from "../../redux/actions/DocumentActions";
import "../dashboard/dashboard.css";

const STEPS = [
  { status: "initiated", label: "Envoyée" },
  { status: "in_progress", label: "En cours" },
  { status: "fulfilled", label: "Terminée" },
];

const STATUS_LABELS = {
  initiated: "En attente",
  in_progress: "En cours",
  fulfilled: "Terminée",
  failed: "Échouée",
};

// Detail of a request made to one of our teams (ticket)
function TicketDetailModal({ show, onHide, ticket }) {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.authUser);
  const [loading, setLoading] = useState(true);
  const [attachments, setAttachments] = useState([]);

  useEffect(() => {
    if (!ticket?.reference || !user?.token) return;

    setLoading(true);
    Promise.resolve(
      dispatch(
        getTicketDocuments(user.token, ticket.reference, (data) =>
          setAttachments(Array.isArray(data) ? data : []),
        ),
      ),
    ).finally(() => setLoading(false));
  }, [ticket?.reference, user?.token, dispatch]);

  if (!ticket) return null;

  const current = STEPS.findIndex((step) => step.status === ticket.status);
  const files = attachments.map((file) => ({
    key: file._id || file.url,
    label: file.name,
    file,
  }));

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <div className="dash-modal-head">
          <Modal.Title as="h2" className="dash-card-title mb-0">
            {ticket.type || "Demande"}
          </Modal.Title>
          <span className="dash-cell-sub">
            #{ticket.reference} ·{" "}
            {moment(ticket.createdAt).format("DD/MM/YYYY")}
          </span>
        </div>
        <StatusBadge
          status={ticket.status}
          label={STATUS_LABELS[ticket.status]}
        />
      </Modal.Header>

      <Modal.Body>
        {current !== -1 && (
          <ol className="dash-steps" aria-label="Avancement">
            {STEPS.map((step, index) => (
              <li
                key={step.status}
                className={index <= current ? "is-done" : ""}
                aria-current={index === current ? "step" : undefined}
              >
                {step.label}
              </li>
            ))}
          </ol>
        )}

        <h3 className="dash-subtitle">Description du besoin</h3>
        <p className="dash-pre">{ticket.description || "—"}</p>

        {ticket.comment && (
          <div className="dash-note">
            <h3 className="dash-subtitle">Réponse de nos équipes</h3>
            <p className="dash-pre">{ticket.comment}</p>
          </div>
        )}

        {loading ? (
          <p className="dash-loading">Chargement des pièces jointes…</p>
        ) : (
          <DocumentList documents={files} />
        )}
      </Modal.Body>
    </Modal>
  );
}

export default TicketDetailModal;
